import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleArea extends TitleBase {
	private areaValue: string;
	private countryValue: string;

	protected canHandle(): boolean {
		this.areaValue = this.getFilterValue(ParameterType.AREA);
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);

		return (
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.AREA)
		);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.areaValue}, ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.titlePortalType, ` in ${this.areaValue}, ${this.countryValue}`);
	}
}
